import { CreateFontPack } from '@/types/theme-packs.types';

export const GetEmptyFontPack = (): CreateFontPack => ({
  title: '',
  description: 'Custom font',
  heading_url: '',
  heading_name: '',
  body_url: '',
  body_name: '',
});
